/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Currencies
 */
export interface Currencies {
    /**
     * Reference currency of the business relationship
     * @type {string}
     * @memberof Currencies
     */
    referenceCurrency?: string;
    /**
     * Charging currency of the business relationship
     * @type {string}
     * @memberof Currencies
     */
    chargingCurrency?: string;
}

/**
 * Check if a given object implements the Currencies interface.
 */
export function instanceOfCurrencies(value: object): value is Currencies {
    return true;
}

export function CurrenciesFromJSON(json: any): Currencies {
    return CurrenciesFromJSONTyped(json, false);
}

export function CurrenciesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Currencies {
    if (json == null) {
        return json;
    }
    return {
        
        'referenceCurrency': json['referenceCurrency'] == null ? undefined : json['referenceCurrency'],
        'chargingCurrency': json['chargingCurrency'] == null ? undefined : json['chargingCurrency'],
    };
}

export function CurrenciesToJSON(json: any): Currencies {
    return CurrenciesToJSONTyped(json, false);
}

export function CurrenciesToJSONTyped(value?: Currencies | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referenceCurrency': value['referenceCurrency'],
        'chargingCurrency': value['chargingCurrency'],
    };
}

